import React, { useMemo } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import moment from 'moment';

const checkValueShouldBeTruthy = (val) => (
    val || val === 0 || val === false || val === ''
);

const defaultFilter = (filter, row) => (checkValueShouldBeTruthy(row[filter.id])
    && row[filter.id].toLowerCase().includes(filter.value.toLowerCase()));

const getFilterMethodForType = {
    string: (filter, row) => (checkValueShouldBeTruthy(row[filter.id])
        && row[filter.id].toLowerCase().includes(filter.value.toLowerCase())),

    date: (filter, row) => (checkValueShouldBeTruthy(row[filter.id])
        && moment(row[filter.id]).format('DD MMM YYYY')
            .toString().includes(filter.value.toString())),

    number: (filter, row) => (checkValueShouldBeTruthy(row[filter.id])
        && row[filter.id].toString().includes(filter.value.toString())),

    boolean: (filter, row) => (checkValueShouldBeTruthy(row[filter.id]) && row[filter.id] === (filter.value))
};

const getFilter = (type) => getFilterMethodForType[type] || defaultFilter;

const getFilterMethod = (column, filterable) => {
    if (column && column.filterMethod) return column.filterMethod;
    return filterable || column.filterable ? getFilter(column.type) : null;
};

const withFilterable = (Component) => {
    const FilterableWrapper = (props) => {
        const columns = useMemo(() => {
            const mapColumn = ({ expander, ...c }) => ({
                ...c,
                filterMethod: getFilterMethod(c, props.filterable)
            });

            const mapColumnGroup = (c) => (c.columns
                ? {
                    ...c,
                    columns: c.columns.map(mapColumnGroup)
                }
                : mapColumn(c)
            );
            return props.columns.map(mapColumnGroup);
        }, [props.columns, props.filterable]);

        return (
            <Component { ...props } columns={ columns } />
        );
    };
    FilterableWrapper.propTypes = {
        filterMethod: PropTypes.func,
        filterable: PropTypes.bool,
        columns: PropTypes.arrayOf(PropTypes.shape({}))
    };

    FilterableWrapper.defaultProps = {
        filterMethod: fp.noop,
        columns: [],
        filterable: false
    };
    return FilterableWrapper;
};

export default withFilterable;
